import { createAsyncThunk } from '@reduxjs/toolkit';
import { lessonTaskApi } from 'common/modules/ReactShared';
import { ISubmitFeedbackBody } from '../../../api/lessonTask/types';

const sendFeedback = createAsyncThunk<
  void,
  { lessonId: number; taskId: number; body: ISubmitFeedbackBody }
>(
  'lessonTask/sendFeedback_request',
  async ({ lessonId, taskId, body }, { rejectWithValue }) => {
    try {
      return await lessonTaskApi.submitLessonTaskFeedback(lessonId, taskId, body);
    } catch (err) {
      return rejectWithValue('Submit error');
    }
  }
);

export const feedbackActions = { sendFeedback };
